import React from 'react';
import { Link } from 'react-router-dom';

type LogoSize = 'sm' | 'md' | 'lg' | 'xl';

interface LogoProps {
  size?: LogoSize;
  linkTo?: string;
  suffix?: string;
  onClick?: () => void;
  className?: string;
}

const sizeConfig = {
  sm: {
    text: 'text-sm font-semibold',
  },
  md: {
    text: 'text-lg font-bold',
  },
  lg: {
    text: 'text-xl font-bold',
  },
  xl: {
    text: 'text-4xl font-bold',
  },
};

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  linkTo,
  suffix,
  onClick,
  className = '',
}) => {
  const config = sizeConfig[size];

  const content = (
    <span className={`${config.text} text-blue-600`}>
      Litrlly{suffix && <span className="text-gray-900">{suffix}</span>}
    </span>
  );

  const baseClassName = `flex items-center ${className}`;

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`${baseClassName} hover:opacity-80 transition-opacity`}
        title="Go to Home"
      >
        {content}
      </button>
    );
  }

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className={`${baseClassName} hover:opacity-80 transition-opacity`}
      >
        {content}
      </Link>
    );
  }

  return <div className={baseClassName}>{content}</div>;
};

export default Logo;
